<bpc-widget [title]="title">
  <div *ngIf="!loading">
    <div class="infographic">
      <div
        class="infographic-item"
        *ngFor="let breakIn of notableBreakIns; let i = index"
        [ngClass]="{
          'full-width': notableBreakIns.length === 1,
          'half-width': notableBreakIns.length === 2,
          'third-width': notableBreakIns.length >= 3
        }"
      >
        <div class="icon">
          <i class="pi pi-briefcase"></i>
        </div>
        <div class="details">
          <h3>{{ breakIn.companyName }}</h3>
          <p><strong>Subject:</strong> {{ breakIn.subject }}</p>
          <!-- <p><strong>Outreach Owner:</strong> {{ breakIn.outreachOwner }}</p> -->
          <p><strong>Elevated By:</strong> {{ breakIn.elevatedBy }}</p>
          <p><strong>Date:</strong> {{ breakIn.date | date:'dd/MM/yy' }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="notableBreakIns.length === 0" class="no-data">
      <h2>No data available</h2>
    </div>
    <!--<div class="table-container">
      <table class="highlight-table">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Subject</th>
            <th>Outreach Owner</th>
            <th>Elevated By</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let breakIn of notableBreakIns">
            <td><strong>{{ breakIn.name }}</strong></td>
            <td>{{ breakIn.subject }}</td>
            <td>{{ breakIn.outreachOwner }}</td>
            <td>{{ breakIn.elevatedBy }}</td>
            <td>{{ breakIn.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    -->
  </div>
  <bpc-dynamic-skeleton-loader [numberOfSkeletons]="loaders" *ngIf="loading"></bpc-dynamic-skeleton-loader>
</bpc-widget>